"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle, Info, WarningOctagon, X } from "@phosphor-icons/react";
import { css } from "@filadd/phi-plus-styled-system/css";
import { Stack } from "@filadd/phi-plus-styled-system/jsx";
import * as Toast from "./BaseToast";
const Icons = ({ type }) => {
    switch (type) {
        case "success":
            return (_jsx(CheckCircle, { size: 19.5, weight: "duotone", className: css({
                    color: "success.800",
                }) }));
        case "error":
            return (_jsx(WarningOctagon, { size: 19.5, weight: "duotone", className: css({
                    color: "error.800",
                }) }));
        case "loading":
        case "info":
        default:
            return (_jsx(Info, { size: 19.5, weight: "duotone", className: css({
                    color: "primary.700",
                }) }));
    }
};
export const toastMachine = Toast.createToaster({
    placement: "top-end",
});
export const Toaster = (props) => (_jsx(Toast.Toaster, Object.assign({ toaster: toastMachine }, props, { children: (toast) => (_jsx(Toast.Root, { type: toast.type, children: _jsxs(Stack, { direction: "row", children: [_jsx(Stack, { alignSelf: "center", children: _jsx(Icons, { type: toast.type }) }), _jsxs("div", { children: [_jsx(Toast.Title, { textWrap: "wrap", maxWidth: "180px", children: toast.title }), _jsx(Toast.Description, { children: toast.description })] }), _jsx(Toast.CloseTrigger, { asChild: true, children: _jsx(X, {}) })] }) })) })));
//# sourceMappingURL=Toast.js.map